import type { ExtractPublicPropTypes } from 'vue'
import {getUnifyTime} from '@el-plus/utils/time'
export interface FooterInfoFieldConfig {
  name: string
  prop: string
  formatter?: (value: any, modelValue: any) => string
}

export const defaultFields: FooterInfoFieldConfig[] = [
  {
    name: '制单人',
    prop: 'creator',
    formatter: (value, modelValue) => `${modelValue.creator}/${modelValue.creatorName}`,
  },
  {
    name: '创建时间',
    prop: 'createTime',
    // 如果有createTimestamp，用createTimestamp格式化
    formatter: (value, modelValue) =>
      modelValue.createTimestamp
        ? getUnifyTime(modelValue.createTimestamp,'time')
        : value,
  },
  {
    name: '最新修改人',
    prop: 'editor',
    formatter: (value, modelValue) => `${modelValue.editor}/${modelValue.editorName}`,
  },
  {
    name: '最新修改时间',
    prop: 'editTime',
    // 如果有editTimestamp，用editTimestamp格式化
    formatter: (value, modelValue) =>
      modelValue.editTimestamp
        ? getUnifyTime(modelValue.editTimestamp,'time')
        : value,
  },
]


export interface FooterInfoFieldMap {
  [key: string]:
  | ((value: any, modelValue: any) => string)
  | {
    name?: string
    formatter: (value: any, modelValue: any) => string
  }
}

export const footerInfoProps = {
  modelValue: {
    type: Object as () => Record<string, any>,
    default: () => ({}),
  },
  list: {
    type: Array as () => FooterInfoFieldConfig[],
    default: () => defaultFields,
  },
  fieldMap: {
    type: Object as () => FooterInfoFieldMap,
    default: () => ({}),
  },
} as const

export type FooterInfoProps = ExtractPublicPropTypes<typeof footerInfoProps>
